import { DialogModeTypes } from '../types';

export interface IDialogData {
  payload: any;
  mode: DialogModeTypes;
}
